import React, { useEffect, useState } from 'react';
import { snakeCase } from 'lodash';
import { Line } from 'react-chartjs-2';
import moment from 'moment';
import { Dispatch } from 'redux';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import AnalyticsCRUDActions from '@mm/state/actions/AnalyticsCRUDActions';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { MainConfig, GraphSeries } from './constants';
import { getMappedData } from './helpers';
import './CustomGraph.pcss';

type OuterProps = {
  dataSeries: GraphSeries[];
};

const useRedux = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();
  const { botId } = useSelector(
    (state: StoreState) => ({
      botId: activeChatbotIdSelector(state),
    }),
    shallowEqual,
  );

  const retrieveData = (dataSeries: GraphSeries[]) => {
    if (botId) {
      const filter = dataSeries.map(field => snakeCase(field)).join(',');
      return dispatch(
        AnalyticsCRUDActions.retrieveAll(
          botId,
          moment().subtract('2', 'weeks'),
          moment(),
          'day',
          filter,
        ),
      );
    }
  };

  return { retrieveData };
};

const SummaryPageGraph = ({ dataSeries }: OuterProps) => {
  const [rawData, setRawData] = useState({ date: [] });
  const { retrieveData } = useRedux();

  useEffect(() => {
    const getRemoteData = async () => {
      const response = await retrieveData(dataSeries);
      setRawData(response);
    };

    getRemoteData();
  }, []);

  //  Explicitly set the width and height to null in order to make the aspectRatio work
  // https://github.com/jerairrest/react-chartjs-2/issues/368
  const lineProps: any = {
    width: null,
    height: null,
    data: (canvas: HTMLCanvasElement) => getMappedData(canvas, rawData),
    options: MainConfig,
  };

  return (
    <div className="website-chat-graph__chart-wrapper">
      <Line {...lineProps} />
    </div>
  );
};

export default SummaryPageGraph;
